import { AUTH_ACTIONS } from "../../constants/actions";

export const setSurveyCompleted = () => ({
  type: AUTH_ACTIONS.AUTH_SET_SURVEY_COMPLETED
});

export const setSurveyIncomplete = () => ({
  type: AUTH_ACTIONS.AUTH_SET_SURVEY_INCOMPLETE
});
